function getGlobalDocument() {
  return document || {}
}

export default getGlobalDocument
